import { enum_ } from 'valibot'

export enum StateMapDisk {
  Cloud = 'cloud',
  LocalStorage = 'ls',
}

export const StateMapDiskSchema = enum_(StateMapDisk, 'Invalid Disk')
